module.exports = __webpack_public_path__ + "static/media/UserCreateError.8da60f53.svg";